import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CalendarComponent } from './calendar/calendar.component';
import { ChatComponent } from './chat/chat.component';
import { KanbanComponent } from './kanban/kanban.component';
import { ProfilComponent } from '../account/auth/profil/profil.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ListAdministrateursComponent } from './component/administrateur/list-administrateurs/list-administrateurs.component';
import { ParametrageMachineComponent } from './component/parametrages/machines/parametrage-machine/parametrage-machine.component';
import { ParametrageProduitsComponent } from './component/parametrages/produits/parametrage-produits/parametrage-produits.component';
import { ParametrageUniteMesureComponent } from './component/parametrages/uniteMesure/parametrage-unite-mesure/parametrage-unite-mesure.component';
import { ParametreGeneralComponent } from './component/parametrages/parametre-general/parametre-general.component';
import { ListCooperativesComponent } from './component/cooperatives/list-cooperatives/list-cooperatives.component';
import { ReservationComponent } from './component/locations/reservation/reservation.component';
import { NouvelleLocationsComponent } from './component/locations/nouvelle-locations/nouvelle-locations.component';
import { ListLocationsComponent } from './component/locations/list-locations/list-locations.component';
import { MembresComponent } from './component/membres/membres.component';
import { StoksComponent } from './component/stoks/stoks.component';
import { ListSuperadminComponent } from './component/superadmin/list-superadmin/list-superadmin.component';
import { AgentsComponent } from './component/agents/agents.component';
import { PaiementDemandeComponent } from './component/locations/paiement-demande/paiement-demande.component';
import { CategorieProduitComponent } from './component/parametrages/Product-categorie/categorie-produit/categorie-produit.component';
import { ListCategorieProductComponent } from './component/parametrages/Product-categorie/list-categorie-product/list-categorie-product.component';
import { VendeurComponent } from './component/vendeur/vendeur.component';
import { LogComponent } from './component/parametrages/log/log.component';
import { AllPaiementMarketplaceComponent } from './component/superadmin/all-paiement-marketplace/all-paiement-marketplace.component';
import { MarketplaceTransactionsPaiementComponent } from './component/superadmin/marketplace-transactions-paiement/marketplace-transactions-paiement.component';
import { TransactionDemandeLocationComponent } from './component/superadmin/transaction-demande-location/transaction-demande-location.component';

const routes: Routes = [
    { path: '', component: DashboardComponent },
    { path: 'administrateurs', component: ListAdministrateursComponent },
    { path: 'list', component: ListSuperadminComponent },
    { path: 'market-place-transactions-retrait', component: AllPaiementMarketplaceComponent },
    { path: 'market-place-transactions-commande', component: MarketplaceTransactionsPaiementComponent },
    { path: 'demande-location-transactions', component: TransactionDemandeLocationComponent },

    //les ecrnas de paramétrages
    { path: 'parametre-machines', component: ParametrageMachineComponent },
    { path: 'parametre-produits', component: ParametrageProduitsComponent },
    { path: 'parametre-unite-mesure', component: ParametrageUniteMesureComponent },
    { path: 'parametre-general', component: ParametreGeneralComponent },
    { path: 'categorie-produit', component: ListCategorieProductComponent },

    //les ecrans cooperatives
    { path: 'cooperatives', component: ListCooperativesComponent },

    //location de machines
    { path: 'locations-machines', component: ListLocationsComponent },
    { path: 'nouvelle-location', component: NouvelleLocationsComponent },
    { path: 'reservation', component: ReservationComponent },
    { path: 'paiement-demande', component: PaiementDemandeComponent },
    { path: 'profil', component: ProfilComponent },
    { path: 'membres', component: MembresComponent },
    { path: 'agents', component: AgentsComponent },
    { path: 'stock', component: StoksComponent },
    { path: 'vendeurs', component: VendeurComponent },
    { path: 'logs', component: LogComponent },






    { path: 'calendar', component: CalendarComponent },
    { path: 'chat', component: ChatComponent },
    { path: 'kanban-board', component: KanbanComponent },
    { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule) },
    { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule) },
    { path: 'pages', loadChildren: () => import('./utility/utility.module').then(m => m.UtilityModule) },
    { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UIModule) },
    { path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule) },
    { path: 'charts', loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule) },
    { path: 'form', loadChildren: () => import('./form/form.module').then(m => m.FormModule) },
    { path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule) },
    { path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule) }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
